<mat-card *ngFor="let notice of displayNotices()">
    <mat-card-title-group>
        <mat-card-subtitle><div [innerHTML]="notice | nl2br"></div></mat-card-subtitle>
        <button mat-icon-button>
            <mat-icon (click)="dismissNotification(notice)">close</mat-icon>
        </button>
    </mat-card-title-group>
</mat-card>